<input type="hidden" [formControl]="control" />

<div class="field">
  <div class="field-label">
    <mat-icon *ngIf="icon">{{ icon }}</mat-icon> {{ label }} <small *ngIf="caption">{{ caption }}</small>
  </div>
  <div class="field-control">
    <mat-button-toggle-group [formControl]="control">
      <mat-button-toggle [value]="true" [checked]="control.value === true">{{ 'INTL_YES' | translate }} </mat-button-toggle>
      <mat-button-toggle [value]="false" [checked]="control.value === false">{{ 'INTL_NO' | translate }} </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
</div>
